<template>
  <div class="partnership-container">
    <div class="page-header">
      <h2>联营管理</h2>
      <p>管理系统中的联营伙伴信息</p>
    </div>
    
    <div class="partnership-content">
      <el-card class="search-filter">
        <div class="card-content">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input placeholder="伙伴名称" v-model="searchParams.name" clearable />
            </el-col>
            <el-col :span="6">
              <el-select placeholder="合作类型" v-model="searchParams.type" clearable>
                <el-option label="设备供应商" value="supplier" />
                <el-option label="清运服务商" value="clearance" />
                <el-option label="回收商" value="recycler" />
                <el-option label="其他" value="other" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select placeholder="合作状态" v-model="searchParams.status" clearable>
                <el-option label="合作中" value="active" />
                <el-option label="已终止" value="terminated" />
                <el-option label="待确认" value="pending" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="handleReset" style="margin-left: 10px;">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
      
      <div class="table-section">
        <el-card>
          <div slot="header" class="clearfix">
            <span>联营伙伴列表</span>
            <el-button type="primary" size="small" style="float: right;">添加伙伴</el-button>
          </div>
          <el-table :data="partnershipData" style="width: 100%">
            <el-table-column type="index" width="50" />
            <el-table-column prop="name" label="伙伴名称" width="180" />
            <el-table-column prop="type" label="合作类型" width="120">
              <template slot-scope="{row}">
                <el-tag size="small">{{ getTypeName(row.type) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="contactPerson" label="联系人" width="120" />
            <el-table-column prop="contactPhone" label="联系电话" width="150" />
            <el-table-column prop="contractStartDate" label="合作开始日期" width="150" />
            <el-table-column prop="contractEndDate" label="合作结束日期" width="150" />
            <el-table-column prop="status" label="合作状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)" size="small">{{ getStatusName(scope.row.status) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template>
                <el-button type="text" size="small">查看</el-button>
                <el-button type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" style="color: #f56c6c;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination" style="margin-top: 20px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalPartners"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="pagination.currentPage"
          :page-size="pagination.page_size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partnership',
  data() {
    return {
      searchParams: {
        name: '',
        type: '',
        status: ''
      },
      pagination: {
        currentPage: 1,
        page_size: 10
      },
      totalPartners: 24,
      partnershipData: [
        {
          id: 1,
          name: '绿源环保设备有限公司',
          type: 'supplier',
          contactPerson: '赵经理',
          contactPhone: '13800138001',
          contractStartDate: '2023-01-01',
          contractEndDate: '2024-12-31',
          status: 'active'
        },
        {
          id: 2,
          name: '城市清运服务集团',
          type: 'clearance',
          contactPerson: '钱主管',
          contactPhone: '13900139002',
          contractStartDate: '2023-02-01',
          contractEndDate: '2024-01-31',
          status: 'active'
        },
        {
          id: 3,
          name: '再生资源回收公司',
          type: 'recycler',
          contactPerson: '孙总',
          contactPhone: '13700137003',
          contractStartDate: '2023-03-01',
          contractEndDate: '2024-02-28',
          status: 'active'
        },
        {
          id: 4,
          name: '清洁服务有限公司',
          type: 'other',
          contactPerson: '李经理',
          contactPhone: '13600136004',
          contractStartDate: '2023-01-01',
          contractEndDate: '2023-06-30',
          status: 'terminated'
        },
        {
          id: 5,
          name: '智慧环保科技公司',
          type: 'supplier',
          contactPerson: '周总监',
          contactPhone: '13500135005',
          contractStartDate: '2023-11-01',
          contractEndDate: '2025-10-31',
          status: 'pending'
        }
      ]
    }
  },
  methods: {
    // 搜索伙伴
    handleSearch() {
      this.pagination.currentPage = 1
      this.$message.success('搜索条件已应用')
    },
    
    // 重置搜索条件
    handleReset() {
      this.searchParams = {
        name: '',
        type: '',
        status: ''
      }
      this.pagination.currentPage = 1
      this.$message.info('搜索条件已重置')
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.page_size = size
    },
    
    // 当前页码变化
    handleCurrentChange(current) {
      this.pagination.currentPage = current
    },
    
    // 获取合作类型名称
    getTypeName(type) {
      const typeMap = {
        'supplier': '设备供应商',
        'clearance': '清运服务商',
        'recycler': '回收商',
        'other': '其他'
      }
      return typeMap[type] || type
    },
    
    // 获取合作状态名称
    getStatusName(status) {
      const statusMap = {
        'active': '合作中',
        'terminated': '已终止',
        'pending': '待确认'
      }
      return statusMap[status] || status
    },
    
    // 获取合作状态对应的标签类型
    getStatusType(status) {
      const typeMap = {
        'active': 'success',
        'terminated': 'danger',
        'pending': 'warning'
      }
      return typeMap[status] || 'default'
    }
  }
}
</script>

<style scoped>
.partnership-container {
  padding: 20px;
}

.page-header h2 {
  color: #303133;
  font-size: 24px;
  margin-bottom: 10px;
}

.page-header p {
  color: #606266;
  font-size: 14px;
  margin-bottom: 30px;
}

.search-filter {
  margin-bottom: 20px;
}

.table-section {
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>